import React, { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandInput, CommandList, CommandEmpty, CommandItem } from "./ui/command";

// Combobox ospite con ricerca rapida per nome o cognome
export default function OspiteCombobox({ value, onChange, ospiti = [], testid, placeholder = "Cerca ospite per nome o cognome..." }) {
  const [open, setOpen] = useState(false);
  const sel = ospiti.find((o) => o.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" data-testid={testid}
          className="w-full h-10 rounded-md border px-3 text-sm flex items-center justify-between gap-2 bg-white">
          <span className={sel ? "truncate" : "text-muted-foreground"}>{sel ? `${sel.cognome} ${sel.nome}` : placeholder}</span>
          <ChevronsUpDown size={15} className="opacity-50 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)]" align="start">
        <Command>
          <CommandInput placeholder="Cerca per nome o cognome..." data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList>
            <CommandEmpty>Nessun ospite trovato</CommandEmpty>
            {ospiti.map((o) => (
              <CommandItem key={o.id} value={`${o.cognome} ${o.nome}`}
                onSelect={() => { onChange(o); setOpen(false); }}
                data-testid={testid ? `${testid}-opt-${o.id}` : undefined}>
                <Check size={14} className={`mr-2 ${value === o.id ? "opacity-100" : "opacity-0"}`} />
                {o.cognome} {o.nome}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
